// Guards a route: redirects to /login when there is no authenticated user.
// While Firebase is still restoring the persisted session (initialising), it
// renders a neutral placeholder instead of redirecting — otherwise a hard
// refresh on a protected route would flash to /login before auth resolves.

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import { SkeletonPage } from '../components/Skeleton.jsx';

export default function ProtectedRoute({ children }) {
  const { user, initialising } = useAuth();

  if (initialising) {
    return <SkeletonPage />;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
